<script setup lang="ts">
import type { EditorialCarouselProductsWithChipsProps } from './EditorialCarouselProductsWithChips.props'
import type { ProductTileProps } from '../UI/UIProductTile.props'

const {
  selectedProducts,
  handleChipSelected,
  titleStrip,
  carouselProducts,
  cardsConfiguration,
  viewAllCtaLink,
} = defineProps<EditorialCarouselProductsWithChipsProps>()

const emit = defineEmits<{ 'add-to-cart': [ProductTileProps] }>()

const localePath = useLocalePath()

const chipsExists = computed(
  () =>
    carouselProducts?.content[0].chip &&
    Object.keys(carouselProducts?.content[0].chip).length > 0
)
</script>

<template>
  <div
    class="editorial-carousel-product-with-chips lg:py-4xl lg:gap-md py-sm md:py-md gap-xs md:gap-sm bg-background-secondary flex flex-col"
  >
    <div
      v-if="titleStrip && Object.keys(titleStrip).length > 0"
      class="title-strip-chips"
    >
      <UITitleStrip v-bind="titleStrip" />

      <div
        v-if="carouselProducts && chipsExists"
        class="px-sm gap-xs md:gap-sm md:px-md lg:gap-md pb-sm flex justify-start overflow-y-auto lg:justify-center lg:px-0"
        :class="{
          'md:justify-center md:px-0': carouselProducts.content.length <= 5,
        }"
      >
        <UICarouselChips
          v-bind="carouselProducts"
          @chip-selected="handleChipSelected"
        />
      </div>
    </div>

    <div class="arrows-swiper-slider">
      <UISliderEditorialWithArrows
        :selected-products-status="selectedProductsStatus"
        :items="selectedProducts"
        :has-no-space-between="cardsConfiguration?.hasNoSpaceBetween"
        :loop="selectedProducts && selectedProducts.length > 3"
        :show-navigation="selectedProducts && selectedProducts.length > 3"
        :type="cardsConfiguration?.type"
        :card-dimensions="cardsConfiguration?.cardDimensions"
        :mobile-centered="cardsConfiguration?.mobileCentered"
        :padding="cardsConfiguration?.padding"
      >
        <template #default="{ item }">
          <UIProductTile
            v-if="!!item"
            v-bind="item"
            class="h-full w-full"
            @open-quick-buy="emit('add-to-cart', item)"
          />
        </template>
      </UISliderEditorialWithArrows>
    </div>

    <div
      v-if="carouselProducts?.viewAllCtaLabel && viewAllCtaLink"
      class="flex items-center justify-center"
    >
      <MoleculesLinkWrapper
        anatomy="link"
        :to="localePath(viewAllCtaLink?.target)"
        class="text-text-primary !md:text-link-5 shrink-0"
        :target="viewAllCtaLink.type === 'blank' ? '_blank' : undefined"
      >
        <template #label>
          <UtilsMarkdown
            v-if="carouselProducts?.viewAllCtaLabel"
            :content="carouselProducts?.viewAllCtaLabel"
            container="span"
            is-preprocessed
          />
        </template>
      </MoleculesLinkWrapper>
    </div>
  </div>
</template>
